import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LineCheckboxCell from '../LineCheckboxCell';
import LineName from '../LineName';
import KababMenuHorizontal from '../../Menu/KababMenuHorizontal';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
    color: theme.palette.brand.greenDark,
  },
  actions: { marginLeft: 'auto', marginRight: theme.spacing(0.5) },
}));

export default function LineNameRow({
  line,
  setAnchorOpened = null,
  setSelectedLine = null,
  actions = null,
  handleEditActiveLineDetails,
  setLineInfoDuringEdit,
  addOrDeleteError,
  lineOnEditMode,
}) {
  const classes = useStyles();

  const showKababMenu =
    !line.editActiveLine &&
    !line.edit &&
    !line.editActiveNameLine &&
    actions?.length > 0;

  return (
    <div className={classes.root}>
      <LineCheckboxCell line={line} />
      <LineName
        {...{
          line,
          handleEditActiveLineDetails,
          setLineInfoDuringEdit,
          addOrDeleteError,
        }}
      />
      {showKababMenu && (
        <div className={classes.actions}>
          <KababMenuHorizontal
            actions={actions}
            setAnchorOpened={setAnchorOpened}
            setSelectedLine={setSelectedLine}
            disabled={lineOnEditMode}
          />
        </div>
      )}
    </div>
  );
}
